module.exports = __webpack_public_path__ + "img/12.761d47dd.png";